"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ServiceNow AI Toolkit
 * ServiceNow AI Toolkit API
 *
 * The version of the OpenAPI document:
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginApi = exports.LoginApiFactory = exports.LoginApiFp = exports.LoginApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * LoginApi - axios parameter creator
 * @export
 */
const LoginApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Fetches the list of available LDAP and OIDC identity providers.
         * @summary Get the list of authentication providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/login/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * User login with ldap credentials with hydra challenge
         * @summary ldap login
         * @param {string} username
         * @param {string} password
         * @param {string} challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ldapLogin: (username_1, password_1, challenge_1, ...args_1) => __awaiter(this, [username_1, password_1, challenge_1, ...args_1], void 0, function* (username, password, challenge, options = {}) {
            // verify required parameter 'username' is not null or undefined
            (0, common_1.assertParamExists)('ldapLogin', 'username', username);
            // verify required parameter 'password' is not null or undefined
            (0, common_1.assertParamExists)('ldapLogin', 'password', password);
            // verify required parameter 'challenge' is not null or undefined
            (0, common_1.assertParamExists)('ldapLogin', 'challenge', challenge);
            const localVarPath = `/login/ldap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            if (username !== undefined) {
                localVarFormParams.set('username', username);
            }
            if (password !== undefined) {
                localVarFormParams.set('password', password);
            }
            if (challenge !== undefined) {
                localVarFormParams.set('challenge', challenge);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initiates the login process with the specified OIDC provider.
         * @summary OIDC login
         * @param {string} providerId The ID of the OIDC provider
         * @param {string} loginChallenge The login challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidcLogin: (providerId_1, loginChallenge_1, ...args_1) => __awaiter(this, [providerId_1, loginChallenge_1, ...args_1], void 0, function* (providerId, loginChallenge, options = {}) {
            // verify required parameter 'providerId' is not null or undefined
            (0, common_1.assertParamExists)('oidcLogin', 'providerId', providerId);
            // verify required parameter 'loginChallenge' is not null or undefined
            (0, common_1.assertParamExists)('oidcLogin', 'loginChallenge', loginChallenge);
            const localVarPath = `/login/oidc/auth/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (loginChallenge !== undefined) {
                localVarQueryParameter['login_challenge'] = loginChallenge;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.LoginApiAxiosParamCreator = LoginApiAxiosParamCreator;
/**
 * LoginApi - functional programming interface
 * @export
 */
const LoginApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.LoginApiAxiosParamCreator)(configuration);
    return {
        /**
         * Fetches the list of available LDAP and OIDC identity providers.
         * @summary Get the list of authentication providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProviders(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoginApi.getProviders']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * User login with ldap credentials with hydra challenge
         * @summary ldap login
         * @param {string} username
         * @param {string} password
         * @param {string} challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ldapLogin(username, password, challenge, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ldapLogin(username, password, challenge, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoginApi.ldapLogin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Initiates the login process with the specified OIDC provider.
         * @summary OIDC login
         * @param {string} providerId The ID of the OIDC provider
         * @param {string} loginChallenge The login challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidcLogin(providerId, loginChallenge, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oidcLogin(providerId, loginChallenge, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoginApi.oidcLogin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.LoginApiFp = LoginApiFp;
/**
 * LoginApi - factory interface
 * @export
 */
const LoginApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.LoginApiFp)(configuration);
    return {
        /**
         * Fetches the list of available LDAP and OIDC identity providers.
         * @summary Get the list of authentication providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders(options) {
            return localVarFp.getProviders(options).then((request) => request(axios, basePath));
        },
        /**
         * User login with ldap credentials with hydra challenge
         * @summary ldap login
         * @param {LoginApiLdapLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ldapLogin(requestParameters, options) {
            return localVarFp.ldapLogin(requestParameters.username, requestParameters.password, requestParameters.challenge, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates the login process with the specified OIDC provider.
         * @summary OIDC login
         * @param {LoginApiOidcLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidcLogin(requestParameters, options) {
            return localVarFp.oidcLogin(requestParameters.providerId, requestParameters.loginChallenge, options).then((request) => request(axios, basePath));
        },
    };
};
exports.LoginApiFactory = LoginApiFactory;
/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
class LoginApi extends base_1.BaseAPI {
    /**
     * Fetches the list of available LDAP and OIDC identity providers.
     * @summary Get the list of authentication providers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    getProviders(options) {
        return (0, exports.LoginApiFp)(this.configuration).getProviders(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * User login with ldap credentials with hydra challenge
     * @summary ldap login
     * @param {LoginApiLdapLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    ldapLogin(requestParameters, options) {
        return (0, exports.LoginApiFp)(this.configuration).ldapLogin(requestParameters.username, requestParameters.password, requestParameters.challenge, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiates the login process with the specified OIDC provider.
     * @summary OIDC login
     * @param {LoginApiOidcLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    oidcLogin(requestParameters, options) {
        return (0, exports.LoginApiFp)(this.configuration).oidcLogin(requestParameters.providerId, requestParameters.loginChallenge, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.LoginApi = LoginApi;
